import { ERROR_MESSAGES, REQUEST } from '../../consts';
import {
  RemoveRelationshipMutation,
  RemoveRelationshipMutationVariables,
} from '../../../types/graphql';
import { apiThunk, httpActions } from '..';

import { Action } from 'redux';
import { Auth } from '@justgiving/auth';
import { IAppState } from '../../types/state.d';
import { ThunkDispatch } from 'redux-thunk';
import apolloClient from '../../apolloClient';
import { getTeamGuid } from '../../selectors/apiSelectors';
import gql from 'graphql-tag';

const unlinkMember = (frpId: string) => async (
  dispatch: ThunkDispatch<IAppState, Auth, Action>,
  getState: () => IAppState,
  auth: Auth,
) => {
  const resourceName = REQUEST.UNLINK_MEMBER;
  try {
    await auth.refreshAccessTokenIfExpired();
    dispatch(httpActions.httpRequestMade(resourceName));
    const state = getState();
    const teamGuid = getTeamGuid(state) as string;

    const { data, errors } = await apolloClient.mutate<
      RemoveRelationshipMutation,
      RemoveRelationshipMutationVariables
    >({
      mutation: gql`
        mutation RemoveRelationship($input: RemoveRelationshipInput!) {
          removeRelationship(input: $input)
        }
      `,
      variables: {
        input: {
          pageId: frpId,
          parentPageId: teamGuid,
        },
      },
    });

    if (errors) {
      throw new Error(ERROR_MESSAGES.UNLINK_MEMBER);
    }

    dispatch(httpActions.httpRequestSuccess(resourceName));
    dispatch(apiThunk.fetchMembersList());
    return data;
  } catch (error) {
    dispatch(httpActions.httpRequestError(resourceName, error as Error));
    throw error;
  }
};

export default unlinkMember;
